package pt.at.oss.kotlin.manual.schema.common.contactinfo

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_INFO_EMAIL_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_INFO_TELEPHONE_MAX_LEN
import pt.at.oss.kotlin.manual.storage.common.contactinfo.ContactInfo
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * ContactInfoSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class ContactInfoSchema : RecordSchema<ContactInfo>(name = "contactInfo") {

    val emailSchema: StringSchema = StringSchema(name = "email", minLength = 1, maxLength = CONTACT_INFO_EMAIL_MAX_LEN)
    val emailConfirmationSchema: StringSchema = StringSchema(name = "emailConfirmation", minLength = 1, maxLength = CONTACT_INFO_EMAIL_MAX_LEN)
    val telephoneSchema: StringSchema = StringSchema(name = "telephone", minLength = 1, maxLength = CONTACT_INFO_TELEPHONE_MAX_LEN)
    override fun isValid(value: ContactInfo?): Boolean {
        return value == null || (
            emailSchema.isValid(value.email) &&
                emailConfirmationSchema.isValid(value.emailConfirmation) &&
                telephoneSchema.isValid(value.telephone)
            )
    }

    override fun validate(value: ContactInfo?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(emailSchema.validate(value.email, appendToPath(path, "email")))
        validator.addErrors(emailConfirmationSchema.validate(value.emailConfirmation, appendToPath(path, "emailConfirmation")))
        validator.addErrors(telephoneSchema.validate(value.telephone, appendToPath(path, "telephone")))
        return validator
    }
}
